import { SUBSCRIPTION_SETTING } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { getIsDiagnosticAssigned, getDiagnostic } from 'store/diagnostics/selectors';
import {
    getAvailableSubscriptions,
    getAvailableSubscriptionsLoadingStatus,
    getCourseActiveSubscriptions,
} from 'store/subscriptions/selectors';

export const getCourseAvailableSubscription = createSelector(
    [getAvailableSubscriptions, getCourseActiveSubscriptions],
    (available, active) => {
        if (active.some(({ subscription }) => subscription.setting === SUBSCRIPTION_SETTING.LONG)) {
            return null;
        }

        return available.find(({ setting }) => setting === SUBSCRIPTION_SETTING.LONG) || null;
    }
);

export const getIsSubscriptionLoading = createSelector(
    [getAvailableSubscriptionsLoadingStatus],
    (subscriptionLoadingStatus) => {
        return (
            subscriptionLoadingStatus === LOADING_STATUSES.UNSENT ||
            subscriptionLoadingStatus === LOADING_STATUSES.LOADING
        );
    }
);

export const getCanCreateNormalLessonFromBanner = createSelector(
    [getCourseAvailableSubscription, getDiagnostic, getIsDiagnosticAssigned],
    (availableSubscription, diagnostic, diagnosticAssigned) => {
        return (!diagnostic || diagnosticAssigned) && !availableSubscription;
    }
);
